import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { scrollIntoView } from './dom';

/**
 * Emulate default browser behavior of automatically scrolling to hash links
 * on page load. This hook is necessary in cases where content is fetched and
 * rendered asynchronously instead of being ready on initial page load.
 */
export function useHashScroll() {
  const [hasScrolled, setHasScrolled] = useState(false);
  const location = useLocation();
  const hash = location.hash.replace(/^#/, '');

  // Deliberately excluding the dependency list so this runs on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function scrollTargetIntoViewIfPresent() {
    const target = document.getElementById(hash);

    if (target && !hasScrolled) {
      scrollIntoView(target);
      setHasScrolled(true);
    }
  });

  useEffect(function resetOnUnmount() {
    return () => setHasScrolled(false);
  }, []);
}
